var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "grid gap-1" }, [
        _c("p", { staticClass: "opacity-50" }, [
          _vm._v(_vm._s(_vm.labelText) + ":"),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "input-room-wrapp relative px-4 py-2 cursor-pointer select-none bg-white input-border whitespace-nowrap truncate",
          },
          [_vm._v(_vm._s(_vm.textToDisplay))]
        ),
      ]),
      _vm._v(" "),
      _c(
        "vue-slider",
        _vm._b(
          { attrs: { value: _vm.value }, on: { change: _vm.handleInput } },
          "vue-slider",
          _vm.$attrs,
          false
        )
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }